<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div>
    <modal
      :visible="isVisible"
      :title="capitalize($t('actions.downloadGeofences'))"
      :body="capitalize($t('messages.chooseAFileFormat'))"
      :button1-visible="true"
      :button1-caption="capitalize($t('actions.cancel'))"
      :button2-visible="false"
      @confirmed="isVisible = false"
      @cancelled="isVisible = false"
      >>
      <template #modal-after-form>
        <div class="flex-v-full">
          <div class="file-types">
            <div class="file-type">
              <a
                href="#"
                data-action-type="download-csv-file"
                @click="downloadGeofencesAsCSV">
                <icon-file-c-s-v />
              </a>
            </div>

            <div class="file-type">
              <a
                href="#"
                data-action-type="download-xlsx-file"
                @click="downloadGeofencesAsXLSX">
                <icon-file-x-l-s />
              </a>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script type="text/babel">
  import Excel from 'exceljs';
  import Papa from 'papaparse';
  import { capitalize } from 'vue';

  import { IconFileCSV, IconFileXLS } from '@/common/icons/monochrome';
  import { generateCSVURI } from '@/utils/CsvUtils';
  import DownloadUtils from '@/utils/DownloadUtils';
  import i18n from '@/vueI18n';

  export default {
    components: {
      IconFileCSV,
      IconFileXLS,
    },
    props: {
      geofenceGroup: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isVisible: false,
        columns: [
          capitalize(i18n.global.t('names.geofenceName', { n: 1 })),
          capitalize(i18n.global.t('names.geofenceDescription', { n: 1 })),
          capitalize(i18n.global.t('names.geofenceLatitude', { n: 1 })),
          capitalize(i18n.global.t('names.geofenceLongitude', { n: 1 })),
          capitalize(i18n.global.t('names.geofenceRadius', { n: 1 })),
          capitalize(i18n.global.t('names.geoJSON', { n: 1 })),
          capitalize(i18n.global.t('names.geofenceID', { n: 1 })),
        ],
      };
    },
    computed: {
      dataRows() {
        return this.geofences.map((x) => [
          x.name,
          x.description,
          x.lat,
          x.lng,
          x.isPoint ? x.radius * 1000 : '',
          x.isPoint
            ? ''
            : JSON.stringify({
                type: 'Feature',
                geometry: x.geometry,
              }),
          x.id,
        ]);
      },
      geofences() {
        return this.geofenceGroup.geofences;
      },
    },
    methods: {
      capitalize(text) {
        return capitalize(text);
      },
      show() {
        this.isVisible = true;
      },
      downloadGeofencesAsCSV() {
        const csv = Papa.unparse({ fields: this.columns, data: this.dataRows });
        const csvContent = generateCSVURI(csv);
        const link = document.createElement('a');
        link.setAttribute('href', csvContent);
        link.setAttribute('download', `${this.geofenceGroup.name}.csv`);
        link.innerHTML = 'Click Here to download';
        document.body.appendChild(link); // Required for FF

        link.click();
        this.isVisible = false;
      },
      downloadGeofencesAsXLSX() {
        const workbook = new Excel.Workbook();

        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 30000,
            height: 20000,
            firstSheet: 0,
            activeTab: 1,
            visibility: 'visible',
          },
        ];

        const sheet = workbook.addWorksheet('Geofences');
        const baseColumnWidth = 10;
        sheet.getColumn(1).width = 2 * baseColumnWidth;
        sheet.getColumn(2).width = 4 * baseColumnWidth;
        sheet.getColumn(3).width = baseColumnWidth;
        sheet.getColumn(4).width = baseColumnWidth;
        sheet.getColumn(5).width = 1.2 * baseColumnWidth;
        sheet.getColumn(6).width = baseColumnWidth;

        sheet.addRow(this.columns);
        this.dataRows.forEach((x) => {
          sheet.addRow(x);
        });

        workbook.xlsx.writeBuffer().then((data) => {
          const blob = new window.Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          DownloadUtils.saveBlobToFile(blob, `${this.geofenceGroup.name}.xlsx`);
        });
        this.isVisible = false;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .file-types {
    display: flex;
    justify-content: center;

    .file-type {
      display: flex;
      flex-direction: column;
      align-content: center;
      margin: 0 2rem;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2.4rem;
        border: solid 1px #0074ff;
        border-radius: 6px;
        background-color: #0074ff05;

        &:hover {
          background-color: #fff;
        }
      }

      svg {
        stroke: var(--secondaryColor);
        fill: var(--secondaryColor);

        width: 6.4rem;
        height: 6.4rem;
        margin-right: 0.1rem;
        margin-bottom: 0.6rem;
      }

      &:first-of-type {
        svg {
          margin-left: 0.1rem;
          margin-right: 0;
        }
      }
    }
  }
</style>
